<template>
<inertia-head title="Bo Sanchez FREE Webinar!" />
<div class="bg-trc-main">
	<div class="bg-black-25">
		<div class="content text-center">
			<div class="py-0 mb-3">
				<h2 class="fw-bold text-white mb-2">
				Join our FREE webinar!
				</h2>
				<h1 class="fw-bold text-white mb-2">
				{{investorZoomEvent? investorZoomEvent.investor_zoom_topic : 'The webinar session has ended'}}
				</h1>
				<div v-if="investorZoomEvent">
					<h3 class="fw-bold mb-2" :class="{'text-white':investorZoomEvent.zoom_dates,'text-warning':!investorZoomEvent.zoom_dates}">
					{{investorZoomEvent? (investorZoomEvent.zoom_dates ? investorZoomEvent.zoom_dates.start_date_format + " from " + investorZoomEvent.zoom_dates.start_time + " - " + investorZoomEvent.zoom_dates.end_time + ' PST(GMT+8)' : 'No Available Zoom Session') : ''}}
					</h3>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="content">
	<div v-if="investorZoomEvent" class="row justify-content-center">
		<div class="col-sm-12 col-md-10 col-lg-8">
			<img :src="investorZoomEvent.investor_zoom_img" alt="" class="img-fluid mb-2">
		</div>
		<div class="col-sm-12 col-md-10 col-lg-8">
			<div v-html="investorZoomEvent.investor_zoom_desc"></div>
		</div>
		<div v-if="investorZoomEvent.zoom_dates" class="col-sm-12 col-md-10 col-lg-8 mt-5">
			<h2 class="text-center">Fill out the details below!</h2>
			<h4 class="text-center">Please ensure you provide a valid email address so we can send you the zoom access.</h4>
			<h1 class="text-center"><i class="fa fa-arrow-down"></i></h1>
			<div class="block block-rounded shadow">
				<div class="block-content block-content-full">
					<!-- <div class="form-group mb-3">
						<label>Choose a Zoom Session</label>
						<select v-model="form.zoom_datetime" id="zoom_datetime" name="zoom_datetime" class="form-select">
							<option value=""></option>
							<option v-for="(zdate,z_index) in investorZoomEvent.zoom_dates" :value="zdate.investor_zoom_date_uuid+'|'+zdate.start_datetime+'|'+zdate.end_datetime">{{zdate.start_date_format}} from {{zdate.start_time}} - {{zdate.end_time}}</option>
						</select>
						<span v-if="form.errors.zoom_datetime" class="text-danger">{{form.errors.zoom_datetime}}</span>
					</div> -->
					<div class="form-group mb-3">
						<label>First Name</label>
						<input type="text" v-model="form.fname" name="fname" class="form-control" />
						<span v-if="form.errors.fname" class="text-danger">{{form.errors.fname}}</span>
					</div>
					<div class="form-group mb-3">
						<label>Last Name</label>
						<input type="text" v-model="form.lname" name="lname" class="form-control" />
						<span v-if="form.errors.lname" class="text-danger">{{form.errors.lname}}</span>
					</div>
					<div class="form-group mb-3">
						<label>Email Address</label>
						<input type="text" v-model="form.email" name="email" class="form-control" />
						<span v-if="form.errors.email" class="text-danger">{{form.errors.email}}</span>
					</div>
					<div class="form-group mb-3">
						<label>Mobile</label>
						<vue-tel-input
						@input="onInput"
						@countryChanged="onCountryChange"
						v-model="form.mobile"
						:value="form.mobile"
						class="form-control"
						:class="{ 'is-invalid': form.errors.mobile }"
						:input-options="{
						placeholder: 'Enter mobile number',
						}"
						:defaultCountry="form.country_code"
						mode="international"
						/>
						<span v-if="form.errors.mobile" class="text-danger">{{form.errors.mobile}}</span>
					</div>
					<div class="form-group mt-4 text-center">
						<button @click="registerZoom()" type="button" class="btn btn-success btn-lg" :disabled="form.processing">
						<div
							v-if="form.processing"
							class="spinner-border spinner-border-sm text-white me-1"
							role="status"
							>
							<span class="sr-only">Loading...</span>
						</div>
						<i v-else class="fa fa-plus me-1"></i>
						Register Now!
						</button>
					</div>
					
				</div>
			</div>
			<div class="block-content block-content-full">
				<p class="text-gray-dark"></p>
			</div>
			<div class="block-content block-content-full">
				<p class="text-center">Your referring affiliate is: {{affiliate_name}}</p>
			</div>
		</div>
	</div>
	<div v-else class="row justify-content-center">
		<error :status='404'/>
	</div>
</div>
<!-- Footer -->
<footer id="page-footer">
	<div class="content py-3">
		<div class="row fs-sm">
			<div class="col-sm-12 order-sm-1 py-1 text-center">
				<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
				&copy; {{ $page.props.app.year }}
			</div>
		</div>
	</div>
</footer>
</template>
<script>
	import GuestLayout from '../Layouts/FreeBookLayout';
	import { watch, ref, onMounted } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: GuestLayout,
		props:{
			flash 				: Object,
			errors 				: Object,
			affiliate			: Number,
			affiliate_name		: String,
			investorZoomEvent	: Object,
		},
		setup(props){
			const form = useForm({
				investor_zoom_event_uuid 	: props.investorZoomEvent ? props.investorZoomEvent.investor_zoom_event_uuid : '',
				zoom_datetime 				: '',
				fname 						: '',
				lname 						: '',
				email 						: '',
				country_calling_code 		: '63',
				country_code				: '',
				mobile						: '',
				affiliate 					: props.affiliate
			})
			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
					form.mobile 				= phoneObject.number;
					form.country_calling_code 	= phoneObject.countryCallingCode;
				}
				if(phoneObject.formatted=='')
				{
					form.mobile = '';
				}
			}
			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2
			}

			const registerZoom = ()=>{

				form.zoom_datetime = props.investorZoomEvent ? (props.investorZoomEvent.zoom_dates ? props.investorZoomEvent.zoom_dates.investor_zoom_date_uuid+"|"+props.investorZoomEvent.zoom_dates.start_datetime+"|"+props.investorZoomEvent.zoom_dates.end_datetime : '') : '';

				form.post(route("post.investor-zoom"),{
					only:['flash','errors','affiliate','affiliate_name'],
					onSuccess:(res)=>{
						if(res.props.flash.toast.type=='success')
						{
							form.zoom_datetime  		='';
							form.fname					='';
							form.fname					='';
							form.lname					='';
							form.email					='';
							form.country_calling_code 	='63';
							form.country_code 			='';
							form.mobile 				='';	
						}
					}
				});
			}

			watch(
				() => props.flash,
				(flash) => {
					if (flash && flash.toast) {
						if(flash.toast.type=='success')
						{
							Inertia.get("/c/investor/thankyou/"+flash.toast.data.attendee_uuid);
						}

					}
				}
			)
			return {
				form,
				onInput,
				onCountryChange,
				registerZoom
			}
		}
	}
</script>